<template>
  <div class="slug">

    <template v-if="product">

      <ProductPdpmodel :product="product" />

      <ProductPdpimagegrid v-if="product.productType !== 'Accessories & Spare Parts'" :product="product" />
      <ContentGravaaSystemSlider class="mt-2 lg:mt-16 mb-12" />
      <ProductSpecification v-if="product.specifications" :product="product" />

    </template>
    <div v-else class="h-screen mt-16 w-screen flex place-items-center border border-red-400">
      <p class="mx-auto">Loading...</p>
    </div>

  </div>
</template>

<script setup>

import { useRoute } from "vue-router";
import { useProductStore } from "~/stores/productStore";
import { useBlogStore } from "@/stores/blogStore";
import { mapProductToGa4Item } from '@/utils/ga4Map';

const { proxy } = useScriptGoogleTagManager({ id: 'GTM-TXPLJB8M' });

const { getSeoProductMeta } = useImageUtils();

const route = useRoute();
const productStore = useProductStore();
const blogStore = useBlogStore();

// Get the product using slug
const product = ref(null);

const fetchProduct = async () => {
  const handle = route.params.slug;
  try {
    const fetchedProduct = await productStore.fetchProductByHandle(handle);
    if (fetchedProduct) {
      product.value = fetchedProduct;

      const seoMeta = getSeoProductMeta(product.value);
      //console.log('SEO Meta:', seoMeta);
      useSeoMeta(seoMeta);
    } else {
      console.warn(`Product not found for handle: ${handle}`);
    }
  } catch (error) {
    console.error(`Error fetching product for handle ${handle}:`, error);
  }
};

// Fetch product at setup level for SSR
await fetchProduct();

onMounted(async () => {
  // If product is null after SSR, show 404 (client-side only)
  if (!product.value) {
    throw createError({
      statusCode: 404,
      statusMessage: 'Product Not Found'
    });
  }

  // Use SEO Composeable after product is loaded (client-side only)
  if (product.value) {
    useProductSeo(product.value);
  }

  console.log(`Pushing page_view for ${window.location.href} page to GTM dataLayer`);
  console.log('Product title:', product.value?.title || '');
  proxy.dataLayer.push({
    event: 'page_view',
    pageType: 'PDP',
    pageUrl: window.location.href,
    pageTitle: product.value?.title || ''
  })

  // Track view_item event for product page
  try {
    if (product.value) {
      const item = mapProductToGa4Item({
        product: product.value,
        listId: 'product_detail_page',
        listName: typeof window !== 'undefined' ? window.location.pathname : ''
      });

      if (item) {
        const currency =
          product.value?.priceRange?.minVariantPrice?.currencyCode ??
          product.value?.variants?.edges?.[0]?.node?.price?.currencyCode ??
          'EUR';

        const value = parseFloat(
          product.value?.priceRange?.minVariantPrice?.amount ||
          product.value?.variants?.edges?.[0]?.node?.price?.amount ||
          '0'
        );

        console.log('Pushing view_item to dataLayer', {
          currency,
          value,
          item
        });

        proxy.dataLayer.push({
          event: 'view_item',
          ecommerce: {
            currency,
            value,
            items: [item]
          },
          pageUrl: typeof window !== 'undefined' ? window.location.href : ''
        });
      }
    }
  } catch (err) {
    console.warn('Error while pushing view_item analytics', err);
  }

});

</script>